module.exports = __webpack_public_path__ + "static/media/left_arrow_icon.de147e5b.svg";